import { render, staticRenderFns } from "./TNTEquivalency.vue?vue&type=template&id=34d2aaca&"
import script from "./TNTEquivalency.vue?vue&type=script&lang=js&"
export * from "./TNTEquivalency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports